import { z } from 'zod';

/**
 * Giga's schema is type-strict: one value of the wrong type stops the widget from loading. Each field
 * coerces what it can and falls back to Giga's empty value of its type: `""`, `-1`, `false` or `[]`.
 */
const gigaString = z.union([z.string(), z.number().transform(String)]).catch('');

const gigaInt = z.union([z.number().int(), z.string().regex(/^\d+$/).transform(Number)]).catch(-1);

const gigaBoolean = z.boolean().catch(false);

const gigaStringList = z.array(z.string()).catch([]);

const gigaUnixSeconds = z
  .number()
  .positive()
  .transform((ms) => Math.floor(ms / 1000))
  .catch(-1);

const isEpochSeconds = (epoch: number): boolean => epoch < 1e12;

const gigaIsoDate = z
  .union([
    z.string(),
    z
      .number()
      .positive()
      .transform((epoch) => new Date(isEpochSeconds(epoch) ? epoch * 1000 : epoch).toISOString()),
  ])
  .catch('');

export const gigaUserSchema = z.object({
  userId: gigaString,
  firstName: gigaString,
  lastName: gigaString,
  email: gigaString,
  phoneNumber: gigaString,
  role: gigaString,
  shippingCountry: gigaString,
  shippingState: gigaString,
  shippingCity: gigaString,
  shippingZipCode: gigaString,
  addressLine1: gigaString,
  subscriptionType: gigaString,
  subscriptionState: gigaString,
  subscriptionStartDate: gigaUnixSeconds,
  subscriptionEndDate: gigaUnixSeconds,
  seasonsActive: gigaInt,
  creditCardOutdated: gigaBoolean,
  creditsInfo: gigaString,
  nextBillDate: gigaIsoDate,
  timezone: gigaString,
  dixaUserId: gigaString,
});

export const gigaOrderSchema = z.object({
  orderId: gigaInt,
  billingDate: gigaString,
  status: gigaString,
  couponCodes: gigaStringList,
  orderShipment: gigaInt,
  carrier: gigaString,
  trackingNumber: gigaString,
  trackingOrderId: gigaInt,
  trackingStatus: gigaString,
  trackingCarrier: gigaString,
  carrierTrackingUrl: gigaString,
  shipmentDate: gigaString,
  estimatedDeliveryDate: gigaString,
  lastCheckpointTag: gigaString,
  lastCheckpointTime: gigaString,
  lastCheckpointMessage: gigaString,
  lastCheckpointLocation: gigaString,
  warehouse: gigaString,
});
